module.exports = "/static/media/meeting.78b0f9a6.svg";